import React from 'react';
import {connect} from 'react-redux';
import DropdownInput from 'components/forms/BasicFormFields/DropdownInput';

const mapStateToProps = state => {
  const {retailers, currentStoreAccountId} = state.rewards;

  let options = [];

  if (retailers) {
    options = retailers.map(retailer => ({
      text: retailer.name + " (" + retailer.retailerCode + ")",
      value: retailer.id
    }));

  }

  return {
    options
  };
};

const RetailerDropdown = connect(mapStateToProps)(DropdownInput);

export default RetailerDropdown;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RetailerItemModal/RetailerDropdown.jsx